module.exports = __webpack_public_path__ + "fonts/iconfont.42c4c519.ttf";